import * as React from 'react';
import Button from 'components/button';
import { ILoginProps } from 'modules/login/login.types';
import Spinner from 'components/spinner/spinner.component';
import { EXTERNAL_LOGIN_OPTIONS, externalLoginOptionType } from 'modules/ubisoft-connect-service/constants';

export default class LoginPopup extends React.Component<ILoginProps, {}> {
    public componentDidMount() {
        this.props.setUpLoginSessionCallback();
    }

    private handleLoginClick = () => {
        this.props.openLoginPopup(EXTERNAL_LOGIN_OPTIONS.UBISOFT as externalLoginOptionType);
    };

    private renderLoginButton(): JSX.Element {
        const { fetching, loginSession } = this.props;
        if (!fetching && !loginSession) {
            return <Button type="primary" onClick={this.handleLoginClick}>Login</Button>;
        }
        return <Spinner/>;
    }

    public render(): JSX.Element {
        return (
            <div className="sitegen-login-page">
                {this.renderLoginButton()}
            </div>
        );
    }
}
